//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Tier from "assets/img/Tier.JPG";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Newsignaturelogo from 'assets/img/Henry Schein Thrive Service plus.png';
// material-ui icons


export default function FormThree({ setNext, setStates, states }) {

  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const handlesubmit = async () => {
    try {
   
      let error = false
     
      if (states?.tier == '') {
        setStates({
          tiererror: true
        })
        error = true
      }
      if (error) {
        return false
      } else {
        setStates({
          tiererror: false

        })
        setNext('4')
      }
    }
    catch (e) {
      console.log({ e });
    }
  }



  return (
    <div style={{ width: '100%', margin: 'auto', marginRight: 'auto', background: '#fff', fontFamily: 'Inter, sans-serif' }}>
        <img style={{ width: "100%" }} src={Newsignaturelogo}></img>
      {/* <div style={{width: '70%', margin: 'auto', marginRight: 'auto', background: '#fff',    border: "groove"}}> */}
      <h2 className={classes.text}>Please Select Your Thrive Service Plus Tier Agreement</h2>
      <hr className={classes.tierhorz}></hr>
      {/* <div className={classes.imgtier}>
        <img src={Tier} alt="logo" />
      </div> */}
      {/* <div className={classes.sel} >Select Your Tier Service Plus Agreement <span style={{ color: 'red' }}>*</span> </div> */}
      <Grid item xs={12} lg={9} className={states?.tiererror ? classes.formRadioError : classes.formtxtRadio}>
      <div className={classes.radio}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue=""
          name="radio-buttons-group"
          value={states?.tier}
          onChange={(e) => {
            setStates({ tier: e?.target?.value,
            tiererror:false })
          }}
        >
          <FormControlLabel value="Tier 1-$299 Per Month (1-6 Operatories)" control={<Radio color="primary" />} label="Tier 1-$299 Per Month (1-6 Operatories)" />
          <FormControlLabel value="Tier 2-$499 Per Month (7-12 Operatories)" control={<Radio color="primary" />} label="Tier 2-$499 Per Month (7-12 Operatories)" />
          <FormControlLabel value="Tier 3-$599 Per Month (13-20 Operatories)" control={<Radio color="primary" />} label="Tier 3-$599 Per Month (13-20 Operatories)" />
        </RadioGroup>
        {states?.tiererror && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
      </div>
      </Grid>
      <div style={{
        border: '1px solid transparent',
        borderTopColor: '#ededf1',
        width: '50%',
        margin: 'auto',
        marginTop: 20,
        paddingTop: 25,
        display: 'flex',
        justifyContent: 'space-between'
      }}>
        <button style={{
          float: 'right',
          border: '1px solid transparent',
          minWidth: '128px',
          height: '3em',
          color: '#000',
          borderRadius: 4,
          background: '#e5e7f2',
          cursor: 'pointer'

        }} onClick={() => setNext('2')}>Back</button>

        <button style={{
          float: 'right',
          border: '1px solid transparent',
          minWidth: '128px',
          height: '3em',
          color: '#fff',
          borderRadius: 4,
          background: '#2e69ff',
          cursor: 'pointer'

        }} onClick={() => handlesubmit()}>Next</button>

      </div>
      {/* </div> */}
      {/* <div>
      <h3>Signature Pad</h3>
      <canvas
        ref={canvasRef}
        style={{ border: "2px solid black", cursor: "crosshair" }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      />
      <div style={{ marginTop: "10px" }}>
        <button onClick={handleClear}>Clear</button>
        <button onClick={handleSave} style={{ marginLeft: "10px" }}>Save</button>
      </div>
    </div> */}
    </div>
  );
}